<!DOCTYPE html>
<app-dataview [identifier]="'catalog-view'" [title]="title" [treedata]="treeItems" [showtreeicon]="true" [showfiltericon]="true" [showtree]="true" 
    [showdragdrop]="true" (expandtreeevent)="expandTree($event)" (onclickheaderdragdrop)="onClickDragDrop()" [usetreescroll]="true" 
    [isLoading]="isLoading || isManifestUpdating" [isResizable]="true"></app-dataview>
